import type {
  CourierDeliveryScheduleListRequestType,
  CourierDeliveryScheduleListResponseType,
} from "@sellar-io/api-v2/types";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2InfiniteQueryOptions,
  apiV2Request,
  getDefaultInfiniteQueryOptions,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useCourierDeliveryScheduleList = <
  TData = CourierDeliveryScheduleListResponseType,
>(
  params: CourierDeliveryScheduleListRequestType,
  options?: ApiV2InfiniteQueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useInfiniteQuery({
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.CourierDeliverySchedule,
      params,
    ],
    queryFn: (queryParams) =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `courier-delivery-schedule`,
        params: {
          ...params,
          offset: queryParams.pageParam,
        },
      }).then((response) => apiV2AssertResponse<TData>(response).data),
    ...getDefaultInfiniteQueryOptions({ ...options, limit: params.limit }),
  });
};
